
/* ======================================================================
   Location-Aware Inventory Gate  +  Bundle Builder  +  Cart Drawer
   ====================================================================== */
(function () {
  /* ---------- CONFIG ------------------------------------------------- */
  const PHP_ENDPOINT      = 'https://shopify.api.nomilk.dev/einrum/locations-data.php';
  const ICELAND_COUNTRY   = 'IS';
  const ICELAND_WAREHOUSE = 'IS';
  const DK_WAREHOUSE      = 'DK';
  const CACHE_TTL         = 30_000;                         // ms
  const ERROR_TXT         = 'Ikke på lager i din region';

  /* ---------- CUSTOMER CONTEXT (Liquid → JS) ------------------------- */
  // Expect a <script id="customer-context" type="application/json"> injected by Liquid
  let __CUSTOMER_CTX = null;
  function readCustomerCtx () {
    if (__CUSTOMER_CTX) return __CUSTOMER_CTX;
    __CUSTOMER_CTX = { loggedIn: false, tags: [] };
    const el = document.getElementById('customer-context');
    if (!el) {
      console.log('[INV] customer-context not found; treating as guest');
      return __CUSTOMER_CTX;
    }
    try {
      const data = JSON.parse(el.textContent || '{}');
      __CUSTOMER_CTX.loggedIn = !!data.loggedIn;
      __CUSTOMER_CTX.tags = Array.isArray(data.tags) ? data.tags.map(t => String(t).toLowerCase()) : [];
      console.log('[INV] customer ctx', __CUSTOMER_CTX);
    } catch (e) {
      console.log('[INV] customer-context parse error', e);
    }
    return __CUSTOMER_CTX;
  }
  const isIcelandB2B = () => {
    const c = readCustomerCtx();
    const match = c.loggedIn && c.tags.some(t => t.includes('b2b-iceland'));
    console.log('[INV] isIcelandB2B =', match);
    return match;
  };

  /* ---------- STATE -------------------------------------------------- */
  const stockCache = new Map();                             // variantId → {IS, DK, ts}
  let   visitorCountry = detectCountry();
  console.log('[INV] visitorCountry =', visitorCountry);

  /* ---------- COUNTRY DETECTION ------------------------------------- */
  function detectCountry () {
    const cookie = document.cookie.split('; ').find(c => c.startsWith('_shopify_country='));
    if (cookie)            return cookie.split('=')[1].toUpperCase();
    if (Shopify?.country)  return Shopify.country;
    if (Shopify?.locale)   return Shopify.locale.split('-').pop().toUpperCase();
    return DK_WAREHOUSE;   // fallback
  }

  /* ---------- STOCK FETCH ------------------------------------------- */
  async function fetchStock (variantIds = []) {
    const idsToFetch = variantIds.filter(id => {
      const rec = stockCache.get(id);
      const stale = !rec || Date.now() - rec.ts > CACHE_TTL;
      console.log(`[INV] cache ${stale ? 'MISS' : 'HIT'} → ${id}`);
      return stale;
    });
    if (!idsToFetch.length) {
      console.log('[INV] no stock fetch needed');
      return;
    }

    console.log('[INV] fetching stock for', idsToFetch);
    const res  = await fetch(PHP_ENDPOINT, {
      method : 'POST',
      headers: {'Content-Type':'application/json'},
      body   : JSON.stringify({ variantIds: idsToFetch })
    });
    if (!res.ok) {
      console.warn('[INV] fetch failed with status', res.status);
      return;
    }
    const data = await res.json();
    Object.entries(data).forEach(([id, payload]) =>
      stockCache.set(+id, {...payload, ts: Date.now()})
    );
    console.log('[INV] stock payload', data);
  }

  /* ---------- AVAILABILITY + RULES ---------------------------------- */
  // How many units are available to THIS customer, by rules
  function availableQtyFor (variantId) {
    const rec = stockCache.get(variantId);
    if (!rec) {
      console.log('[INV] qty unknown for variant', variantId, '(no cache yet)');
      return null; // unknown until fetch completes
    }

    const isIS = visitorCountry === ICELAND_COUNTRY;
    const isQty = Math.max(0, +rec[ICELAND_WAREHOUSE] || 0);
    const dkQty = Math.max(0, +rec[DK_WAREHOUSE] || 0);

    if (isIS && !isIcelandB2B()) {
      console.log('[INV] rule: IS retail → IS only | IS=', isQty);
      return isQty;
    }
    if (isIS && isIcelandB2B()) {
      console.log('[INV] rule: IS B2B → IS+DK pooled | IS=', isQty, 'DK=', dkQty, 'TOTAL=', isQty + dkQty);
      return isQty + dkQty;
    }
    console.log('[INV] rule: outside IS → DK only | DK=', dkQty);
    return dkQty;
  }

  function allowedToBuy (variantId, qtyNeeded = 1) {
    const qty = availableQtyFor(variantId);
    if (qty === null) {
      console.log('[INV] optimistic allow (no data yet) for variant', variantId);
      return true; // optimistic until first payload
    }
    const ok = qty >= qtyNeeded;
    console.log(`[INV] allowedToBuy? variant=${variantId} need=${qtyNeeded} have=${qty} → ${ok}`);
    return ok;
  }

  /* ---------- Helpers ----------------------------------------------- */

  function getCurrentVariantId () {
    const inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const id  = inp ? Number(inp.value) : null;
    console.log('[INV] current variant id =', id);
    return id || null;
  }

  function updateCustomerFacingQty (variantId) {
    const span = document.querySelector('.custom-inventory .stock-number');
    if (!span) return;
    const qty = availableQtyFor(variantId);
    if (qty === null) return; // wait for first fetch
    span.textContent = qty;
    console.log('[INV] .advantage__title span updated →', qty);
  }

  // Replace your existing helper with this:
  function setBtnDisabled(btn, disabled, labelDisabled = 'Ikke på lager') {
    const isInput = btn.tagName === 'INPUT';

    // inner label setter that works across markup patterns
    const setLabel = (text) => {
      // Most themes: plain button text node
      if (!isInput) btn.textContent = text;

      // Dawn-like: nested span
      btn.querySelector?.('.button__text') && (btn.querySelector('.button__text').textContent = text);

      // Inputs: change the value attribute
      if (isInput) btn.value = text;

      // Optional data attr some themes use
      if (btn.hasAttribute('data-default')) btn.setAttribute('data-default', text);
    };

    if (disabled) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('inactive');
      setLabel(labelDisabled);
      console.log('[INV] ATC set DISABLED →', labelDisabled, btn);
    } else {
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'false');
      btn.classList.remove('inactive');
      setLabel('Tilføj til kurv');
      console.log('[INV] ATC set ENABLED → Tilføj til kurv', btn);
    }
  }

  function updateATCButtons(variantId) {
    const ok = allowedToBuy(variantId);
    const buttons = [
      ...document.querySelectorAll('#AddToCart'),
      ...document.querySelectorAll('.product-form__submit')
    ];
    buttons.forEach(btn => setBtnDisabled(btn, !ok, 'Ikke på lager'));
    console.log('[INV] ATC buttons updated →', ok ? 'ENABLED' : 'DISABLED');
    updateCustomerFacingQty(variantId);
  }

  /* ========== VARIANT SWATCH UI ===================================== */
  function updateVariantSwatches () {
    document.querySelectorAll('label.color-swatch[data-variant-id]').forEach(label => {
      const id = +label.dataset.variantId;
      if (!id) return;
      const ok = allowedToBuy(id);
      label.classList.toggle('swatch-sold-out', !ok);
      label.querySelector('.no-stock-badge')?.style.setProperty('display', ok ? 'none' : 'block');
      console.log('[INV] swatch', id, ok ? 'OK' : 'SOLD OUT');
    });
  }

  /* ========== BUNDLE BUILDER UI ===================================== */
  function collectBundleVariantIds () {
    return [...document.querySelectorAll('.slide-in__values-container .yarn-color[data-id]')]
      .map(el => +el.dataset.id)
      .filter(Boolean);
  }
  function updateBundleUI () {
    document.querySelectorAll('.slide-in__values-container .yarn-color[data-id]').forEach(el => {
      const id = +el.dataset.id;
      const ok = allowedToBuy(id);
      el.classList.toggle('yarn-sold-out', !ok);
      el.querySelector('input.yarn-input')?.setAttribute('disabled', !ok);
      el.querySelector('.sold-out-badge')?.style.setProperty('display', ok ? 'none' : 'block');
      console.log('[INV] bundle item', id, ok ? 'ENABLED' : 'DISABLED');
    });
  }

  /* ========== CART DRAWER LOGIC ===================================== */
  function cartVariantId (cartItemEl) {
    const link = cartItemEl.querySelector('a[href*="variant="]')?.href || '';
    const id   = +(new URL(link).searchParams.get('variant'));
    return id || null;
  }
  function collectCartVariantIds () {
    return [...document.querySelectorAll('.drawer__cart-items-wrapper .cart-item')]
      .map(cartVariantId)
      .filter(Boolean);
  }
  function refreshCartControls () {
    document.querySelectorAll('.drawer__cart-items-wrapper .cart-item').forEach(el => {
      const id     = cartVariantId(el);
      const qtyInp = el.querySelector('.quantity__input');
      const plus   = el.querySelector('.quantity__button[name="plus"]');
      const errBox = el.querySelector('.cart-item__error-text');
      if (!id || !qtyInp || !plus) return;

      const desired = Number(qtyInp.value) + 1;
      const ok      = allowedToBuy(id, desired);
      plus.classList.toggle('disabled', !ok);

      if (!ok) {
        errBox.textContent = ERROR_TXT;
        el.classList.add('error');
      } else {
        errBox.textContent = '';
        el.classList.remove('error');
      }
      console.log('[INV] cart line variant=', id, 'desired=', desired, ok ? 'ALLOW' : 'BLOCK');
    });
  }

  /* ---------- EVENT HANDLERS ---------------------------------------- */
  document.addEventListener('click', async evt => {
    const btn = evt.target.closest('.drawer__cart-items-wrapper .quantity__button');
    if (!btn) return;
    const cartItem = btn.closest('.cart-item');
    const id       = cartVariantId(cartItem);
    if (!id) return;

    await fetchStock([id]);      // Ensure freshest stock
    refreshCartControls();       // Re-check limits

    if (btn.name === 'plus' && btn.classList.contains('disabled')) {
      evt.preventDefault();
      evt.stopPropagation();
      console.log('[INV] plus blocked – variant', id);
    }
  });

  // --- PDP QUANTITY CONTROLS (respect customer-specific availability) ---
  function updatePdpQuantityControls(variantId) {
    const wrap   = document.querySelector('.product-parameters__quantity');
    if (!wrap) return;
    const buyButton = document.querySelector('.product-form__quantity__add__buttons .product-form__submit');
    const inp    = wrap.querySelector('.quantity__input');
    const plus   = wrap.querySelector('.quantity__button-plus');
    const minus  = wrap.querySelector('.quantity__button-minus');
    const errorMs = document.querySelector('.error-message');
    if (!inp) return;

    const avail = availableQtyFor(variantId);

    if (avail === null) {
      // We don't know yet (first fetch pending): no max clamp, keep controls active
      inp.removeAttribute('max');
      plus?.classList.remove('disabled');
      console.log('[INV] PDP qty: pending stock → no max');
      return;
    }

    const max = Math.max(0, Number(avail) || 0);
    inp.setAttribute('max', String(max));

    // Clamp current value into [min..max] (min default is 1 on your markup)
    const min = Number(inp.getAttribute('min')) || 1;
    let cur   = Number(inp.value) || min;

    if (max === 0) {
      // No purchasable stock for this customer; keep value at min but block ATC elsewhere
      cur = min;
      plus?.classList.add('disabled');
      console.log('[INV] PDP qty: max=0 → plus disabled');
    } else {
      if (cur > max) cur = max;
      const atMax = cur >= max;
      plus?.classList.toggle('disabled', atMax);
    }

    // sync back the (possibly clamped) value
    if (String(inp.value) !== String(cur)) inp.value = String(cur);

    // enable/disable minus based on min
    const atMin = cur <= min;
    minus?.classList.toggle('disabled', atMin);
    if(max >= 10){
      console.log('__________INSIDE MAX >= 10___________');
      console.log(inp);
      inp.setAttribute('value', '10');
      inp.innerHTML = '10';
    }
    if(cur < min){
      console.log('__________INSIDE CUR___________');
      if (errorMs) {
        errorMs.style.display = 'flex';
        errorMs.querySelector('span').textContent = `Minimum to order is ${min} pcs.`;
        errorMs.removeAttribute('hidden');
      }

      buyButton.setAttribute('disabled', 'disabled');
      buyButton.classList.add('inactive');
    }else{
      if (errorMs) {
        errorMs.style.display = 'none';
        errorMs.setAttribute('hidden', 'true');
      errorMs.querySelector('span').textContent = '';
      }
      
      buyButton.removeAttribute('disabled');
      buyButton.classList.remove('inactive');
    }
    
    console.log('[INV] PDP qty set →', { min, max, cur, avail });
  }

  // Guardrail: clamp on manual typing and on +/- clicks
  function bindPdpQuantityClamping() {
    const wrap = document.querySelector('.product-parameters__quantity');
    if (!wrap) return;

    // Manual typing
    wrap.addEventListener('input', (e) => {
      const target = e.target.closest('.quantity__input');
      if (!target) return;
      const vId = getCurrentVariantId();
      if (!vId) return;

      const min = Number(target.getAttribute('min')) || 1;
      const maxAttr = target.getAttribute('max');
      const max = maxAttr != null ? Number(maxAttr) : Infinity;
      let val = Number(target.value) || min;
      val = Math.min(Math.max(val, min), max);
      if (String(target.value) !== String(val)) target.value = String(val);

      // keep +/- button states in sync
      updatePdpQuantityControls(vId);
    });

    // Clicks on theme +/- buttons
    wrap.addEventListener('click', (e) => {
      const btn = e.target.closest('.quantity__button');
      if (!btn) return;
      const vId = getCurrentVariantId();
      if (!vId) return;

      // After theme increments/decrements, re-apply clamp + button states
      requestAnimationFrame(() => updatePdpQuantityControls(vId));
    });
  }


  /* ---------- INIT -------------------------------------------------- */
  let __INIT_DONE = false;
  async function init () {
    if (__INIT_DONE) return; __INIT_DONE = true;
    console.log('[INV] init start');

    /* product page */
    if (meta?.product) {
      wireVariantRadios(); // <— NEW: make your radios drive variant selection

      const ids = meta.product.variants.map(v => v.id);
      await fetchStock(ids);
      updateVariantSwatches();

      const initialVid = getCurrentVariantId();
      if (initialVid) { 
        updateATCButtons(initialVid);
        updatePdpQuantityControls(initialVid); // ← NEW
      }
      bindPdpQuantityClamping();

      // Keep this listener too; it will receive our dispatched event
      document.body.addEventListener('variant:changed', async e => {
          const vId = e?.detail?.variant?.id || getCurrentVariantId();
          console.log('[INV] variant:changed handler picked up →', vId);
          if (!vId) return;
          await fetchStock([vId]);
          updateVariantSwatches();
          updateATCButtons(vId);
          updateBundleUI();
          updatePdpQuantityControls(vId);
      });
    }

    /* bundle builder */
    const bundleIds = collectBundleVariantIds();
    if (bundleIds.length) {
      await fetchStock(bundleIds);
      updateBundleUI();
    }

    /* cart drawer */
    const cartIds = collectCartVariantIds();
    if (cartIds.length) {
      await fetchStock(cartIds);
      refreshCartControls();
    }

    /* refresh on drawer open (Ajax) */
    document.addEventListener('cart:drawerOpened', async () => {
      const ids = collectCartVariantIds();
      console.log('[INV] drawer opened; ids=', ids);
      if (ids.length) {
        await fetchStock(ids);
        refreshCartControls();
      }
    });

    console.log('[INV] init complete');
  }

  /* ---------- KICK-OFF ---------------------------------------------- */
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
    document.addEventListener('DOMContentLoaded', init);
  }

  /* ---------- COUNTRY WATCHER --------------------------------------- */
  setInterval(() => {
    const cur = detectCountry();
    if (cur !== visitorCountry) {
      console.log('[INV] country changed', visitorCountry, '→', cur);
      visitorCountry = cur;
      updateBundleUI();
      refreshCartControls();

      const vId = getCurrentVariantId();
      if (vId) {
        updateVariantSwatches();
        updateATCButtons(vId);
        updatePdpQuantityControls(vId); 
      }
    }
  }, 10_000);

    // --- VARIANT RADIO WIRING (works with your markup) ---
    function ensureVariantHiddenInput () {
    // Most themes already have this; create if missing
    let form = document.querySelector('form[action*="/cart/add"]');
    if (!form) {
        console.log('[INV] product form not found');
        return null;
    }
    let hid = form.querySelector('input[name="id"]');
    if (!hid) {
        hid = document.createElement('input');
        hid.type = 'hidden';
        hid.name = 'id';
        form.appendChild(hid);
        console.log('[INV] created hidden variant input');
    }
    return hid;
    }

    function wireVariantRadios () {
    ensureVariantHiddenInput();

    // 1) Handle click/keyboard selection on color swatch labels (optional, logs)
    document.addEventListener('click', e => {
        const label = e.target.closest('label.color-swatch[data-variant-id]');
        if (!label) return;
        const vId = Number(label.dataset.variantId);
        if (!vId) return;
        console.log('[INV] swatch label clicked → variant', vId);
    });

    // 2) Main handler: when a variant radio changes, promote to selected variant
    document.addEventListener('change', async e => {
        const inp = e.target.closest('input[type="radio"][data-variant-radio]');
        if (!inp) return;

        const vId = Number(inp.dataset.variantId);
        if (!vId) {
        console.log('[INV] radio change without variant id; ignoring');
        return;
        }

        const hid = ensureVariantHiddenInput();
        if (hid) {
        hid.value = String(vId);
        console.log('[INV] form hidden id <-', vId);
        }

        // Optional: keep URL in sync ?variant=ID (no reload)
        try {
        const url = new URL(location.href);
        url.searchParams.set('variant', String(vId));
        history.replaceState({}, '', url);
        console.log('[INV] URL replaced with ?variant=', vId);
        } catch (err) {
        console.log('[INV] URL replaceState failed', err);
        }

        // Ensure freshest stock for the newly selected variant
        await fetchStock([vId]);

        // Update all dependent UIs
        updateVariantSwatches();
        updateATCButtons(vId);       // updates #AddToCart + .product-form__submit + advantage span
        updateBundleUI();

        // Dispatch the event your module also listens for (for compatibility)
        const evt = new CustomEvent('variant:changed', { detail: { variant: { id: vId } }});
        document.body.dispatchEvent(evt);
        console.log('[INV] dispatched variant:changed →', vId);
    });
    }


})();
